var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brandlogo"},[_c('img',{attrs:{"src":require("../assets/image/evtools.png"),"alt":"EVtools"}}),(_vm.context !== 'login')?_c('span',{staticClass:"logo-sub"},[_vm._v(" workflow ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }